import React from 'react';

const TargetBlankIcon = ({size = 24}) => (
  <svg viewBox="0 0 12 12" width={size} height={size}>
    <path fill="currentColor"
          d="M11.8 4.45 7.69.89a.56.56 0 0 0-.93.42V3.2C2.99 3.23 0 3.99 0 7.55a4.8 4.8 0 0 0 1.95 3.62c.32.23.78-.06.66-.44-1.06-3.4.5-4.3 4.14-4.35v2.06c0 .48.57.73.93.42l4.13-3.56a.56.56 0 0 0 0-.85Z"
    />
  </svg>
);

export default TargetBlankIcon;
